import { render, staticRenderFns } from "./HighAnalitycsDashboard.vue?vue&type=template&id=20957406&scoped=true"
import script from "./HighAnalitycsDashboard.vue?vue&type=script&lang=js"
export * from "./HighAnalitycsDashboard.vue?vue&type=script&lang=js"
import style0 from "./HighAnalitycsDashboard.vue?vue&type=style&index=0&id=20957406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20957406",
  null
  
)

export default component.exports